(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/dialog-wager-content/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/racing/dialog-wager-content/assets/javascripts/prescript.js');

'use strict';

svs = svs || {};
svs.racing = svs.racing || {};
svs.racing.dialog_wager_content = svs.racing.dialog_wager_content || {};


 })(window);